import { render, staticRenderFns } from "./ChatApp.vue?vue&type=template&id=4838d276&"
import script from "./ChatApp.vue?vue&type=script&lang=js&"
export * from "./ChatApp.vue?vue&type=script&lang=js&"
import style0 from "./ChatApp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports